import { render, staticRenderFns } from "./modifyPersonalData.vue?vue&type=template&id=36179990&scoped=true"
import script from "./modifyPersonalData.vue?vue&type=script&lang=js"
export * from "./modifyPersonalData.vue?vue&type=script&lang=js"
import style0 from "./modifyPersonalData.vue?vue&type=style&index=0&id=36179990&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36179990",
  null
  
)

export default component.exports